import React from 'react';
import styled, { css } from 'styled-components';
import { Classable, HasChildren, Shapeable } from '@shapeable/types';
import { Slice } from '@shapeable/rhodian-types';
import { breakpoints, theme } from '@shapeable/theme';
import { DarkMode, Grid, GridProps, useEntity } from '@shapeable/ui';
import { ProductCard } from './product-card';
import { classNames } from '@shapeable/utils';

const cls = classNames('product-grid');

// -------- Types -------->

export type ProductGridProps = Classable & HasChildren & GridProps & { 
  entity?: Slice;
};

export const ProductGridDefaultProps: Omit<ProductGridProps, 'entity'> = {
  desktopAutoColumns: 2,
  tabletAutoColumns: 2,
};

// -------- Child Component Props -------->

type ContainerProps = {

}

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
    
  `,
});

const GridStyles = breakpoints({
  base: css`
    
  `,
});

const CardStyles = breakpoints({
  desktop: css`
    
  `,
});






// -------- Components -------->

const My = {
  Container: styled.div<ContainerProps>`${ContainerStyles}`,
    Grid: styled(Grid)`${GridStyles}`,
      Card: styled(ProductCard)`${CardStyles}`,
};

export const ProductGrid: Shapeable.FC<ProductGridProps> = (props) => {
  const { className, children, desktopAutoColumns, tabletAutoColumns } = props;
  const entity = useEntity(props.entity);
  const { products = [] } = entity
  
  return (
    <My.Container className={cls.name(className)}>
      <Grid 
        maxColumns={2}
        desktopFullHdMinColumns={desktopAutoColumns}
        desktopLargeMinColumns={desktopAutoColumns}
        desktopMinColumns={desktopAutoColumns}
        landscapeAutoColumns={1}
        items={products.map(Card => 
          <DarkMode><My.Card key={Card.id} entity={Card} /></DarkMode>
        
        )}/>
    {children}
    </My.Container>
  )
};

ProductGrid.defaultProps = ProductGridDefaultProps;
ProductGrid.cls = cls;

